import { BackgroundThemeRevision } from 'referral-types';
import LiquidCheeseBackground from './subthemes/LiquidCheese';
import IntergalacticHighwayBackground from './subthemes/IntergalacticHighway';
import PlanetaryRingsBackground from './subthemes/PlanetaryRings';
import './_styles.scss';

enum SubThemes {
  liquidCheese = 'liquid-cheese',
  planetaryRings = 'planetary-rings',
  intergalacticHighway = 'intergalactic-highway',
}

export const RippleSubThemeOptions = [
  { value: SubThemes.liquidCheese, label: 'Liquid Cheese' },
  { value: SubThemes.planetaryRings, label: 'Planetary Rings' },
  { value: SubThemes.intergalacticHighway, label: 'Intergalactic Highway' },
];

export const RippleBackgrounds = (props: { themeRevision?: Partial<BackgroundThemeRevision> }) => {
  const { themeRevision } = props;

  switch (themeRevision?.subTheme as SubThemes) {
    case SubThemes.liquidCheese:
      return <LiquidCheeseBackground {...props} />;
    case SubThemes.planetaryRings:
      return <PlanetaryRingsBackground {...props} />;
    case SubThemes.intergalacticHighway:
      return <IntergalacticHighwayBackground {...props} />;
    default:
      return <LiquidCheeseBackground {...props} />;
  }
};
